const maskAccountNumber = (accountNumber?: string | null) => `*** ${accountNumber?.slice(-3)}`;
export default maskAccountNumber;
